import { render, staticRenderFns } from "./CivilStatusAddNew.vue?vue&type=template&id=fcd84d86"
import script from "./CivilStatusAddNew.vue?vue&type=script&lang=js"
export * from "./CivilStatusAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports